import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNewTranslation } from 'hooks'
import ReminderAlert from 'particles/Alert/ReminderAlert'
import {
    selectSidebarTask,
    selectSidebarStep,
    selectReviewPendingSubmission,
    selectIsCaptionReviewDone,
    setIsCaptionReviewDone,
} from 'state/review'
import { selectCampaign } from 'state'
import { getTasksList } from 'state/tasks'

interface DeadlineHeaderAlertProps {
    campaignUuid: string
}

const DeadlineHeaderAlert: React.FC<DeadlineHeaderAlertProps> = ({ campaignUuid }) => {
    const [t] = useNewTranslation()
    const dispatch = useDispatch()
    const selectedTask = useSelector(selectSidebarTask)
    const selectedStep = useSelector(selectSidebarStep)
    const campaign = useSelector(selectCampaign(campaignUuid))
    const isAiCaptionReviewEnabled = campaign.brand.team?.is_ai_caption_review_enabled
    const isCaptionReviewsDone = selectedStep?.is_caption_reviews_done
    const isVerifyMode = useSelector(selectReviewPendingSubmission)
    const latestIsCaptionReviewDone = useSelector(selectIsCaptionReviewDone)
    const isContentSubmitStep = selectedStep?.type.includes('submit_content')
    const [showBanner, setShowBanner] = useState<boolean>(false)
    const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null)
    const requireCheckCaptionReviewDone =
        isContentSubmitStep && isAiCaptionReviewEnabled && isVerifyMode && isCaptionReviewsDone === false
    const setCaptionReviewCallback = (isCaptionReviewDone: boolean) => {
        dispatch(setIsCaptionReviewDone(isCaptionReviewDone))
    }
    useEffect(() => {
        if (requireCheckCaptionReviewDone && latestIsCaptionReviewDone === false) {
            if (intervalId === null) {
                const checkIntervalId = setInterval(() => {
                    dispatch(
                        getTasksList({
                            campaignUuid,
                            verifyCaptionReviewTaskUuid: selectedTask?.uuid,
                            captionReviewCallback: setCaptionReviewCallback,
                        }),
                    )
                }, 90000)
                setIntervalId(checkIntervalId)
            }
            if (!showBanner) {
                setShowBanner(true)
            }
        } else {
            if (intervalId) {
                clearInterval(intervalId)
            }
        }
        return () => {
            if (intervalId) {
                clearInterval(intervalId)
            }
        }
    }, [requireCheckCaptionReviewDone, latestIsCaptionReviewDone, campaignUuid, intervalId])
    useEffect(() => {
        return () => {
            dispatch(setIsCaptionReviewDone(false))
        }
    }, [])
    if (!showBanner) {
        return null
    } else {
        if (latestIsCaptionReviewDone) {
            return (
                <ReminderAlert
                    form="positive"
                    title={t('reminder.aiFinishProcessTitle')}
                    width="100%"
                    action={{
                        label: t('button.refreshPage'),
                        callback: () => window.location.reload(),
                    }}
                />
            )
        } else {
            return <ReminderAlert form="info" title={t('reminder.aiProcessingTitle')} width="100%" />
        }
    }
}

export default DeadlineHeaderAlert
